export default __webpack_public_path__ + "static/media/vip2.ccca6015.gif";